import { therapyPlanningAction } from '../../actions/constant';

const {
  GET_AUTHORIZATION_DETAILS_REQUEST,
  GET_AUTHORIZATION_DETAILS_SUCCESS,
  GET_AUTHORIZATION_DETAILS_FAILURE,
  GET_AUTHORIZATION_DETAILS_LOADER,
  GET_AUTHORIZATION_DETAILS_RESET,
} = therapyPlanningAction;
const intitialstate: object = {
  response: null,
  loading: false,
  isGetAuthDetails: false,
};

export const getAuthorizationDetailsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_AUTHORIZATION_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetAuthDetails: true,
      };
    }

    case GET_AUTHORIZATION_DETAILS_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetAuthDetails: false,
      };
    case GET_AUTHORIZATION_DETAILS_LOADER:
      return {
        ...state,
        loading: true,
      };

    case GET_AUTHORIZATION_DETAILS_RESET:
      return intitialstate;
    default:
      return state;
  }
};
